// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ResponseHandler$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as CreateCustomerEntityMapper from "../entity-mapper/CreateCustomerEntityMapper.bs.js";

var execute = CreateCustomerEntityMapper.execute;

var CreateCustomerConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var CreateCustomerResponseConveror = partial_arg(CreateCustomerConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  CreateCustomerConfig ,
  CreateCustomerResponseConveror ,
  
}
/* CreateCustomerResponseConveror Not a pure module */
